export const contactsData = {
    email: 'tarekyosry8@gmail.com',
    phone: '+2 01024787218',
    address: 'Cairo, Egypt',

    sheetAPI: 'https://sheetdb.io/api/v1/tt5b8x0x5sbmo'
}
